module.exports = __webpack_public_path__ + "img/6c36333.png";